import React from 'react';
import { Typography, Paper } from '@mui/material';

const AboutPage = () => {
  return (
    <Paper sx={{ p: 2, mt: 2 }}>

      <Typography variant="h6" gutterBottom>About FlightIQ</Typography>
      <Typography variant="body1" paragraph>
        FlightIQ isn’t just another drone app — it’s the future of safe, intelligent, and accessible aerial operations. 
        We’re building a mission-control platform that delivers the kind of situational awareness and decision-making 
        tools previously reserved for professional pilots, now in the hands of every drone operator.
      </Typography>
      <Typography variant="body1" paragraph>
        By combining real-time FAA Temporary Flight Restrictions (TFR) data, detailed controlled airspace mapping, 
        hyper-local weather forecasting, live geomagnetic activity, and even nearby aircraft tracking, FlightIQ 
        gives operators a crystal-clear <strong>GO / ADVISORY / NO-GO</strong> status — instantly. 
        It’s more than data; it’s actionable intelligence.
      </Typography>
      <Typography variant="body1" paragraph>
        Our platform pulls real time data to bring together everything a pilot needs in one intuitive interface. 
        With expansion plans that include LAANC integration, historical flight logs, and cross-platform mobile apps, 
        FlightIQ will set a new standard for flight planning and safety.
      </Typography>
      <Typography variant="body1" paragraph>
        Backing this project means helping shape the future of unmanned aviation — from recreational pilots to 
        commercial operators. With your support, we will launch FlightIQ worldwide, making every drone flight 
        smarter, safer, and more connected than ever before.
      </Typography>
	    <a href="https://docs.google.com/forms/d/e/1FAIpQLSfVZ5F6s6Grw-1Rxl1rjOTrTu6hrAZKdSrUFvLrVlQmfFjPpA/viewform?usp=header" target="_blank" rel="noopener noreferrer">
    Contact Me
  </a>
    </Paper>
  );
};

export default AboutPage;
